<template>
    <div>
        <confirmation-popup
            title="Warning"
            message="Are you sure you want to delete this custom product??"
            :id="confirmationDialogId" @on-confirm="onCustomProductDeleteConfirm(service.service_id,service.clone)"></confirmation-popup>
        <div v-for="(product,index) of customProducts" :key="JSON.stringify(index)">
            <custom-product
                v-model="customProducts[index]"
                :product="customProducts[index]"
                :service="service"
                :currency="currency"
                :component-counter="index"></custom-product>
        </div>
    </div>

</template>

<script>
import ConfirmationPopup from "../../../common/components/ConfirmationPopup.vue";
import {EventBus} from "../../../../events/event-bus";

export default {
    name: "customProducts",
    components: {ConfirmationPopup},
    props: {
        value: {
            type: Array,
            required: true
        },
        service: {
            required: true,
            type: Object,
        },
        currency: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            confirmationDialogId: `custom-product-confirmation_${this.service.service_id}_${this.service.clone}`,
            toBeDeletedCustomProduct: null,
            customProducts: [],
        }
    },
    created() {
        // add custom product
        EventBus.$on('onCustomProductAdded',  (custom,service_id,clone) => {
                if (service_id === this.service.service_id&& clone===this.service.clone) {
                    this.customProducts.push({
                        description: "",
                        costPricePerUnit:(1).toFixed(2),
                        discount: (0).toFixed(2),
                        discountType: "%",
                        suppliedBy: "",
                        salePricePerUnit:(2).toFixed(2),
                        MarkupPerUnit: "",
                        markupType: "%",
                        quantity: (0).toFixed(2),
                    })
                }
        });

        // remove custom product
        EventBus.$on('onCustomProductDelete', (component_number,service_id,clone) => {
                if (service_id === this.service.service_id && clone ===this.service.clone) {
                    $(`#${this.confirmationDialogId}`).modal('show')
                    this.toBeDeletedCustomProduct = component_number
                }
        });
    },
    methods: {
        onCustomProductDeleteConfirm(service_id,clone) {
            if (service_id === this.service.service_id&& clone===this.service.clone) {
            this.customProducts.splice(this.customProducts.indexOf(this.toBeDeletedCustomProduct), 1)
        }
        }
    },
    watch: {
        customProducts: {
            handler: function (value) {
                this.$emit('input', value)
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>